/**
 * Where the current access token lives: a module-level variable, not
 * localStorage or sessionStorage.
 *
 * That's deliberate. A token in Web Storage is readable by any script that
 * runs on the page — including one slipped in by an XSS bug in a dependency
 * you didn't audit closely enough. A token that only ever exists as a JS
 * variable disappears the moment the tab closes and can't be read by
 * anything outside this module. Losing it on refresh is the trade-off, and
 * `AuthProvider` covers that by silently calling /api/auth/refresh (which
 * reads the httpOnly cookie the browser kept) on mount.
 */

let accessToken = null;
let onSessionExpired = null;

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(token) {
  accessToken = token;
}

export function clearAccessToken() {
  accessToken = null;
}

/** AuthProvider registers a callback here so httpClient can force a logout when refresh fails. */
export function setSessionExpiredHandler(handler) {
  onSessionExpired = handler;
}

export function notifySessionExpired() {
  onSessionExpired?.();
}
